import React from 'react';
import { css } from '@emotion/react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { Select } from '../mui/select';
import { color } from '@/styles';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const ContentContainer = css`
  width: 480px;
  margin-bottom: 16px;
`;

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const ContentTitle = css`
  margin-bottom: 2px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3em;
  border-bottom: 3px solid ${color.dark_gray};
`;

const InheritedWidth = css`
  width: inherit;
`;

const InnerRowContainer = css`
  height: 72px;
`;

const Unit = css`
  min-width: 25px;
  font-size: 16px;
  text-align: right;
  margin: 16px 5px 0 5px;
  white-space: nowrap;
`;

const MarginTop = css`
  margin-top: 8px;
`;

const FlexColumn = css`
  display: flex;
  flex-direction: column;
`;

const StyledSelect = css`
  text-align: left;
`;

export const CareRecordLaxativeSection = ({ form }: Props) => {
  const { t } = useTranslation();
  const isLaxativeIdDisabled = !!form.defecationVolumeType || form.isLeakOutFeces !== null;
  const isLaxativeAmountDisabled = !form.laxativeId || form.isEmptyLaxativeId;

  React.useEffect(() => {
    if (isLaxativeAmountDisabled) {
      form.setLaxativeAmount(null);
    }
  }, [isLaxativeAmountDisabled, form.setLaxativeAmount]);

  return (
    <div css={[ContentContainer]}>
      <div css={[AlignCenter, ContentTitle]}>{t('laxative', '下剤')}</div>
      <div css={[FlexColumn, MarginTop, InheritedWidth, StyledSelect]}>
        <div css={[AlignCenter, InnerRowContainer]}>
          <Select
            id={'laxative-selector'}
            listData={form.laxativeList}
            value={form.laxativeId}
            disabled={isLaxativeIdDisabled}
            label={t('laxativeType', '服用下剤の種類')}
            fullWidth={true}
            isEmptyValue={form.isEmptyLaxativeId}
            onChange={form.handleChangeLaxativeId}
          />
        </div>
        <div css={[AlignCenter, InnerRowContainer]}>
          <TextField
            id={'laxative-volume-field'}
            label={t('dose', '服用量')}
            type={'number'}
            value={form.laxativeAmount ?? ''}
            disabled={isLaxativeAmountDisabled}
            onChange={form.handleChangeLaxativeAmount}
            fullWidth={true}
          />
          <span css={Unit}>{form.laxativeUnit}</span>
        </div>
      </div>
    </div>
  );
};
